import React from 'react';
import { useState } from 'react';
import axios from 'axios';

const url = 'https://icanhazdadjoke.com/';
const Joke = () => {
    const [joke, setJoke] = useState('random dad joke');
    // const [loading, setLoading] = useState(true)
    const fetchDadJoke = async () => {
        try {
            const { data } = await axios(url, {
                headers: {
                    Accept: 'application/json',
                },
                
            });
            // setLoading(false)
            setJoke(data.joke);
           
        } catch (error) {
            console.log(error.response);
        }
    };
    // if (loading) {
    //     <h1 className='display-6'> Loading...</h1>
    // }
    return (
        <section
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="1500"
        className='sectionzz p-5 text-center'>
            <button className='btns fw-bolder' onClick={fetchDadJoke}>
                random joke
            </button>
            <p className='dad-joke fs-4 lead fw-bolder '>{joke}</p>
        </section>
    );
};

export default Joke;